import { defineStore } from 'pinia';
export default defineStore('other', {
    state: () => {
        return {
            userShowNameData: {
                '${startUserName}': '流程发起人',
                '${appointedAssignee}': '指定审批人',
            },
        };
    },
    getters: {
        getUserShowNameData() {
            return this.userShowNameData;
        },
    },
    actions: {
        setUserShowNameData(data) {
            this.userShowNameData = data;
        },
    },
});
